<template>
  <div class="common-tab-box" :style="{marginTop:marginTop}">
    <div
      :class="tabIndex == index ? 'common-tab-list common-tab-active' : 'common-tab-list'"
      v-for="(item, index) in tabList"
      :key="index"
      @click="tabClick(item, index)"
    >
      {{ item.tabName }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: [],
    },
    marginTop:{
      type: String,
      default: '16px',
    }
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    tabClick(item, index) {
      this.tabIndex = index;
      this.$emit('tabChange', item, index);
    },
  },
};
</script>
<style scoped>
/* 页面tab */
.common-tab-box {
  display: flex;
  height: 32px;
  line-height: 32px;
  color: #666;
  margin-top: 16px;
  border-bottom: 1px solid #e5e5e5;
  outline: none;
}
.common-tab-list {
  padding: 0 20px;
  margin: 0 5px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
.common-tab-active {
  color: #4fa1a4;
  border-bottom: 2px solid #4fa1a4;
}
</style>
